"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMatchingLayers = exports.getNewPrintableLayers = void 0;
const designs_1 = require("../../../services/designs");
const either_1 = require("../../../types/either");
const layers_1 = require("../../../services/layers");
const getNewPrintableLayers = (sku, projectAction, layers, projectTemplate) => {
  // console.log('layers in getNewPrintableLayers: ', layers.map(layer => ({x: layer.x, zIndex: layer.zIndex, id: layer.id})))
  const designResult = (0, designs_1.findMatchingOrDefaultDesign)({
    newTemplateDesigns: projectTemplate.designs,
    designId: projectAction.designId
  });
  if (designResult.isLeft()) {
    return (0, either_1.left)(designResult.value);
  }
  const design = designResult.value;
  const newLayersResult = (0, exports.getMatchingLayers)(projectTemplate.layers, design.layers);
  if (newLayersResult.isLeft()) {
    return (0, either_1.left)(newLayersResult.value);
  }
  ;
  const newLayers = newLayersResult.value;
  let mergedLayers = [...newLayers];
  const isCompositeDesign = !!(design.allowedPages !== 'first' && design.coverage && design.coverage === 'partial');
  // this is only for the interior pages of books, when we update from full-spread to partial
  // we need to make the composite design to have the 2 partial in one printable
  if (isCompositeDesign) {
    const shiftedLayers = (0, layers_1.shiftDesignLayersRight)(sku, newLayers, projectTemplate.surface);
    mergedLayers = (0, layers_1.makeCompositeDesign)(projectAction.activePage || '', layers, newLayers, shiftedLayers, projectTemplate.surface);
  }
  return (0, either_1.right)({
    mergedLayers,
    isCompositeDesign
  });
};
exports.getNewPrintableLayers = getNewPrintableLayers;
const getMatchingLayers = (layers, ids) => {
  if (!ids.length) {
    return (0, either_1.right)([]);
  }
  const matchingLayers = layers.filter(layer => {
    return ids.includes(layer.id);
  });
  if (matchingLayers.length === 0) {
    return (0, either_1.left)(new Error(`Could not find matching layers for ids: ${ids.join()}`));
  }
  return (0, either_1.right)(matchingLayers);
};
exports.getMatchingLayers = getMatchingLayers;